var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHotSpringOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0857 20C33.0968 20.5245 33.9592 21.2957 34.593 22.2421C35.2268 23.1886 35.6116 24.2797 35.7114 25.4144C35.7114 30.0795 28.6775 33.8744 20 33.8744C11.3225 33.8744 4.28857 30.1037 4.28857 25.4386C4.38453 24.2996 4.76736 23.2036 5.40136 22.2526C6.03537 21.3016 6.89989 20.5266 7.91429 20",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.942 8.51859C8.10776 14.5614 17.7763 16.9786 12.942 23.0214",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 6.10144C15.1656 12.1443 24.8342 19.3957 19.9999 25.4386",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.058 8.51859C22.2237 14.5614 31.8923 16.9786 27.058 23.0214",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotSpringOutline);
export default __webpack_public_path__ + "static/media/icon_hot_spring_outline.7c454b46b3a60bd6d95616ce4eea4e5f.svg";
export { ForwardRef as ReactComponent };